import React from "react";
import {  GoogleMap, MarkerF } from "@react-google-maps/api";
import { useGoogleMaps } from "../../hooks/useGoogleMaps";

const containerStyle = {
  width: "75%",
  height: "30vh",
};

interface LiveLocationMapProps {
  latitude: number;
  longitude: number;
}

const LiveLocationMap: React.FC<LiveLocationMapProps> = ({
  latitude,
  longitude,
}) => {
  const center = {
    lat: latitude,
    lng: longitude,
  };

  const { isLoaded, loadError } = useGoogleMaps();

  if (loadError) {
    return <div>Error loading maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading maps</div>;
  }

  return (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={10}>
      <MarkerF position={center} />
    </GoogleMap>
  );
};

export default LiveLocationMap;
